import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import { EmailInputField, EMAIL_INVALID_MESSAGE } from 'common/components/form_fields';
import isEmail from 'sane-email-validation';

const RequestForm = ({error, handleSubmit, submitting, submitFailed, onClose}) => (
  <form onSubmit={handleSubmit} noValidate>
    <fieldset>
      <Field name="email" label="Email Address" component={EmailInputField} />
    </fieldset>

    <div className="modal-actions">
      <AnimatedButton processing={submitting} type="submit" label="Reset password"
        processingLabel="Sending link..." errorMsg={error || submitFailed}
        successMsg="Link sent!" />

      <button className="btn btn-text" onClick={onClose}>
        Cancel
      </button>
    </div>
  </form>
)

const validate = values => {
  const errors = {}

  /* validate email */
  if (!isEmail(values['email'] || '')) {
    errors['email'] = EMAIL_INVALID_MESSAGE
  }

  return errors
}

export default reduxForm({
  form: "PasswordResetRequestForm",
  validate,
})(RequestForm);
